module.exports = "<div class=q-section> <div class=q-marg-all-xl> <div class=\"q-alert q-alert-red\"> Serial number entry is invalid. </div> </div> <div class=q-marg-all-xl> <p>Please make sure you have entered the correct value as the serial number and that it contains no commas (,), periods (.), spaces, and meets the max. character length of 25 characters.</p> <p>No other values other than the serial number will be accepted in this entry.</p> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/fxoReceivingScreen/html/invalidEntryModalBodyForSerialNumber.html
// module id = 1317
// module chunks = 1